import { AgentSiteSettingModel } from '@/__generated';
import PageLoading from '@/components/App/PageLoading';
import { handleApiUnKnowError } from '@/helpers/errorHandle';
import { apiSdk } from '@/httpClient';
import React from 'react';
import { createContext, useContext } from 'react';

interface IAppSiteSetting extends AgentSiteSettingModel {
  loaded: boolean;
}
const SiteSettingContext = createContext<IAppSiteSetting>({ loaded: false, cutoffDays: 0 });

export const SiteSettingProvider = ({ children }: { children: React.ReactElement }) => {
  const [settings, setSettings] = React.useState<IAppSiteSetting>({ loaded: false, cutoffDays: 0 });

  React.useEffect(() => {
    apiSdk.SiteSettingService.getSiteSettings()
      .then(res => {
        setSettings({ ...res, loaded: true });
      })
      .catch(handleApiUnKnowError);
  }, []);

  if (!settings.loaded) {
    return <PageLoading />;
  }
  return <SiteSettingContext.Provider value={settings}>{children}</SiteSettingContext.Provider>;
};

export const useGetSiteSettings = () => {
  return useContext(SiteSettingContext);
};
